import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-event-business-payments-table',
	templateUrl: './event-business-payments-table.component.html',
	styleUrls: ['./event-business-payments-table.component.css'],
})
export class EventBusinessPaymentsTableComponent extends ListComponent {
	protected apiUrl = 'eventBusinessPayments';
	protected itemsBeforeDataLoad = 3;
	data: any[];
	pageSizeOptions: number[] = [50, 100, 200];
	filters;
	tableColumnsDef = [
		{ col: 'newId', header: 'Id', size: '80' },
		{ col: 'name', header: 'Wydarzenie', size: '820' },
		{ col: 'date_from', header: 'Od', size: '140' },
		{ col: 'date_to', header: 'Do', size: '140' },
		{ col: 'date', header: 'Data wpłaty', size: '100' },
		{ col: 'value', header: 'Wartość', size: '80' },
		{ col: 'currency', header: 'Waluta', size: '60' },
		{ col: 'clientEvent', header: 'Klient', size: '200' },
	];

	protected summaryColumns = [
		{ id: 'amount', name: 'Suma kwoty' },
		{ id: 'currency', name: 'Waluta' },
	];

	parameters = {
		date_from: null,
		date_to: null,
		organization: [],
		profile: [],
	};

	protected loadBefore(): void {
		this.bag.get('/organization/short_name/?limit=9999', (result, error) => {
			result.results?.forEach((obj) => (obj.id = obj.id.toString()));
			this.parameters.organization = result.results;
			this.loadData();
		});
		this.bag.get('/profile/data_full/?limit=9999', (result, error) => {
			result.results?.forEach((obj) => (obj.id = obj.id.toString()));
			this.parameters.profile = result.results;
			this.loadData();
		});
	}

	filtersSelected(data): void {
		this.filters = data;
		if (!this.filters.date_from) {
			this.filters.date_from = this.date.daysAdd(-15);
		}
		if (!this.filters.date_to) {
			this.filters.date_to = this.date.daysAdd(+15);
		}
		this.loadData();
	}

	protected generateSummary(data: any): any[] {
		const sumAmount = data?.reduce((a, b) => {
			const i = a.findIndex((x) => x.currency === b.currency);
			if (i === -1) {
				a.push({
					currency: b.currency,
					amount: +b.value,
				});
			} else {
				a[i].amount += +b.value;
			}
			return a;
		}, []);
		return this.parseSummaryTable(sumAmount);
	}

	protected parseSummaryTable(data: any[]): any[] {
		return data?.map((obj) => {
			obj.amount = obj.amount.toFixed(2);
			return obj;
		});
	}

	protected convertData(data: any) {
		data['summary'] = this.generateSummary(data);
		data.forEach((obj) => {
			if (obj.clientEvent?.isOrganization === '1') {
				obj.clientEvent = this.findObject(this.parameters.organization, obj.clientEvent?.client)?.shortName;
			}
			if (obj.clientEvent?.isOrganization === '0') {
				obj.clientEvent = this.findObject(this.parameters.profile, obj.clientEvent?.client);
				obj.clientEvent = obj.clientEvent.firstName + ' ' + obj.clientEvent.lastName;
			}
		});
		return data;
	}

	protected findObject(arr, item) {
		return arr?.find((objfind) => objfind.id === item);
	}
}
